import * as Common from '@/agiles/common';

export class CustomTemplate extends Common.ObjectBase{
    constructor(){
        super('CustomTemplate');
    }
    public code: string = '';
    public description: string ='';
    public template: string = '';    
    public enabled:boolean = true;
}

export class CustomTemplateQuery extends Common.LoadQuery {
    constructor(){
        super('CustomTemplateQuery',CustomTemplate);
        this.sort = 'code';
    }
}